// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eSR8","label":"styles_label__3cm88"};